<template>
  <div
    class="d-flex-column justify-start align-start"
    style="margin-top: 50px; margin-bottom: 50px"
    v-if="Object.keys(translations).length > 0"
  >
    <h4
      class="t-light-orange title-h4 font-family-1 f-w-600"
      style="max-width: 70%"
    >
      <!-- {{ getTranslation(`game.${currentGameSlug}.optimal_text.title`) }} -->
      {{ translations[`game.${currentGameSlug}.optimal_text.title`] }}
    </h4>

    <div
      class="d-flex-column justify-start align-start optimal_text_area gap-24"
      style="margin-top: 10px"
    >
      <div
        class="d-flex-column justify-start align-start"
        v-for="(value, key) in translations"
        :key="key"
      >
        <!-- <p
          class="t-white"
          v-if="key !== `game.${currentGameSlug}.optimal_text.title`"
        >
          {{ key }}
        </p> -->
        <h5
          class="t-orange font-family-2 regular-xxl f-w-500 d-flex-row justify-start gap-5"
          v-if="
            key !== `game.${currentGameSlug}.optimal_text.title` &&
            !key.includes('answer')
          "
          v-html="translations[key]"
        ></h5>
        <div
          class="t-white regular-m font-family-2 optimal_text_answer"
          :class="[otherClass]"
          v-if="
            key !== `game.${currentGameSlug}.optimal_text.title` &&
            !key.includes('question')
          "
          v-html="value"
        ></div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from "vue";

const translations = ref({});
const { currentGameSlug } = useGameComposable();
const { getLocale } = useFunctions();
const { textArray, otherClass } = defineProps({
  textArray: {
    default: [],
  },
  otherClass: {
    default: "",
  },
});

const { data: response } = await useApiFetch("/api/get-game-optimal-text", {
  method: "post",
  fetchKey: `get-optimal-text-${currentGameSlug}`,
  body: {
    game: currentGameSlug,
    locale: getLocale(),
  },
  lazy: true,
});

// console.log(response.value);
if (response.value?.data) {
  translations.value = response.value?.data;
}
watch(response, (newVal) => {
  if (newVal?.data) {
    translations.value = newVal?.data;
  }
});
</script>
